import {
  AutoComplete,
  Button,
  Form,
  Input,
  Select,
  Popconfirm,
  Spin,
} from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router";
import { Link } from "react-router-dom";
import { responseNotification } from "../../utils/notify";
import { authenticateToken } from "../../utils/auth";
import { debounce } from "lodash";
import {
  getPage,
  getParamValue,
  jcTypeArray,
  checkStatesAndPushToHistory,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import usePrevious from "../../hooks/PreviousState";
const { Option } = Select;

const Neighborhood = () => {
  const history = useHistory();
  const router = useLocation();
  const [key, setKey] = useState("");
  const [visible, setVisible] = useState(undefined);
  const [type, setType] = useState(
    getParamValue(router.search, "type") || "JC_MART"
  );
  const [limit, setLimit] = useState(16);
  const [polygonOptions, setPolygonOptions] = useState<any>({
    loading: false,
    list: null,
  });
  const [neighborhoodData, setNeighborhoodData] = useState<any>({
    loading: false,
    data: null,
  });
  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const reseAllFieldData = () => {
    setKey("");
    setType("JC_MART");
    form.resetFields();
    history.replace(window.location.pathname);
    window.location.reload();
  };

  const previousType = usePrevious(type);
  const previousKey = usePrevious(key);
  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberNeighborhoodList",
      JSON.stringify({
        key: key,
        type: type,
        page: page,
      })
    );
  };
  const getNeighborhood = useCallback(async () => {
    let pageReseted = false;

    setNeighborhoodData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/neighborhood/all` +
          (type ? `?type=${type}` : ``) +
          (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
          (limit ? `&limit=${limit}` : ``) +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setNeighborhoodData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setNeighborhoodData({ loading: false, data: [] });
      });
  }, [limit, page, type, key]);

  const getPolygonOptions = useCallback(async (key) => {
    setPolygonOptions({ loading: true, list: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/neighborhood/all` +
          (type ? `?type=${type}` : ``) +
          (key ? `&key=${key}` : ``) +
          `&page=${page || 0}` +
          `&limit=${limit || 16}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setPolygonOptions({
          loading: false,
          list: res.data?.neighborhoods?.map((neighborhood: any) => ({
            label: neighborhood.name,
            value: neighborhood.name,
          })),
        });
      })
      .catch((err) => {
        setPolygonOptions({ loading: false, list: [] });
      });
  }, []);

  useEffect(() => {
    getNeighborhood();
  }, [getNeighborhood]);

  const fetchRef = useRef(0);
  const polygonSearchDebounce = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getPolygonOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getPolygonOptions]);

  const [confirmLoading, setConfirmLoading] = useState(false);
  const showPopconfirm = (id: any) => {
    setVisible(id);
  };
  const handleCancel = () => {
    setVisible(undefined);
  };
  const onDelete = async (id: any) => {
    if (id) {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/neighborhood/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: id,
            deleted: true,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification(
              "Neighborhood Deleted Successfully",
              "success"
            );
            getNeighborhood();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  return (
    <React.Fragment>
      <TopHeading
        total={neighborhoodData?.data?.totalElements}
        refetch={getNeighborhood}
      />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item initialValue={type}>
            <Select
              placeholder="Type"
              onChange={(val) => setType(val)}
              value={type}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
        <Form.Item name="search" initialValue={key}>
          <AutoComplete
            onSearch={getPolygonOptions}
            onSelect={(val) => setKey(val.toString())}
            options={polygonOptions?.list}
            defaultActiveFirstOption={false}
            notFoundContent={
              polygonOptions?.loading ? <Spin size="small" /> : null
            }
            style={{ width: 300 }}
          >
            <Input.Search
              size="large"
              placeholder="Search by Name"
              onSearch={(val) => setKey(val)}
              enterButton
              loading={polygonOptions.loading}
              maxLength={11}
            />
          </AutoComplete>
        </Form.Item>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Neighborhood Name</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>View</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {neighborhoodData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {neighborhoodData?.data?.neighborhoods?.length ? (
                    neighborhoodData?.data?.neighborhoods?.map(
                      (neighborhood: any, index: any) => (
                        <React.Fragment key={index}>
                          <Link
                            to={`/neighborhood/${neighborhood?.id}/${neighborhood?.type}/details`}
                          >
                            <div className="single-product-wrapper">
                              <div className="single-product">
                                <span className="name">
                                  {neighborhood?.name}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  {neighborhood?.type?.replace("_", " ")}
                                </span>
                              </div>

                              <div className="single-product">
                                <Link
                                  className="btn btn-sm btn-warning mx-1"
                                  to={`/neighborhood/${neighborhood?.id}/${neighborhood?.type}/details`}
                                >
                                  <EyeOutlined />
                                </Link>

                                <Popconfirm
                                  placement="left"
                                  title="Are you sure to delete?"
                                  visible={neighborhood?.id === visible}
                                  onConfirm={() => onDelete(neighborhood?.id)}
                                  okButtonProps={{ loading: confirmLoading }}
                                  onCancel={handleCancel}
                                >
                                  <button
                                    className="btn btn-sm btn-danger mx-1"
                                    onClick={() =>
                                      showPopconfirm(neighborhood?.id)
                                    }
                                  >
                                    <DeleteOutlined />
                                  </button>
                                </Popconfirm>
                              </div>
                            </div>
                          </Link>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Neighborhood" />
                  )}
                </div>
              </div>
            )}
          </div>

          <PaginationTwo
            {...neighborhoodData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Neighborhood;
